const ROUTE_GROUP = 'group';
const ROUTE_PERSON = 'person';
const ROUTE_MENU = 'menu';
export const ROUTE_TYPES = {
  ROUTE_GROUP,
  ROUTE_PERSON,
  ROUTE_MENU
};

const ACTION_GROUP = 'route_group';
const ACTION_PERSON = 'route_person';
const ACTION_HANGUP = 'hang_up';
const ACTION_VOICEMAIL = 'voicemail';
const ACTION_AUDIO = 'audio';
const ACTION_MENU = 'menu';
export const ACTION_TYPES = {
  ACTION_GROUP,
  ACTION_PERSON,
  ACTION_HANGUP,
  ACTION_VOICEMAIL,
  ACTION_AUDIO,
  ACTION_MENU
};
